<template>
  <v-container fluid>
    <v-row class="justify-end">
      <v-spacer></v-spacer>
      <v-col class="d-inline-flex align-center align-content-space-around">
        <v-btn small outlined class="default-btn mr-4" @click="prevMonth">1개월</v-btn>
        <date-picker :date.sync="startDate"></date-picker>
        <span class="mx-4">~</span>
        <date-picker :date.sync="endDate"></date-picker>
        <v-btn small outlined class="default-btn mx-4" @click="retrieveGrid">조회</v-btn>
        <v-btn small outlined class="excel_down" @click="excelDown">엑셀 다운로드</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <real-grid
          ref="dataGrid"
          class="mt-1 mb-5 w-full"
          :options="grid.gridOption"
          :fields="grid.gridFields"
          :columns="grid.gridColumns"
          :height="grid.height"
          :retrieve-api="gridRetrieveApi"
        ></real-grid>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getBrokenRecord } from '@/api/pcs/siteWork'
import DatePicker from '@/components/monitoring/DatePicker'
import day from 'dayjs'
import RealGrid from '@/components/grid/Realgrid'
import Message from '@/utils/message'

var gridView
var dataProvider
var listCount = 0 // 받은 정보 리스트 갯수
var paegSize = 10 // 한페이지당 보여주는 수
var pageCount = 0 // 총 페이지 갯수

export default {
  name: 'BrokenRecord',
  components: {
    DatePicker,
    RealGrid
  },
  props: {
    tabIndex: {
      type: Number,
      default: -1
    },
    SITE_ID: { type: String, default: '' },
    INVERTER_ID: { type: String, default: '' },
    STATION_ID: { type: String, default: '' }
  },
  data() {
    return {
      endDate: day().format('YYYY-MM-DD'),
      startDate: day()
        .add(-6, 'day')
        .format('YYYY-MM-DD'),
      grid: {
        height: 442.5,
        gridOption: {
          gridView: {
            edit: {
              appendable: true,
              insertable: true,
              deletable: true
            },
            setGroupingOptions: {
              enabled: false // header 그룹핑 옵션을 사용하지 않는다.
            },
            checkBar: {
              visible: false
            },
            panel: {
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            }
          },
          dataProvider: {
            softDeleting: true,
            // 해당 옵션이 false 이면 추가된 행을 삭제했을 경우 -+ 표시가 생긴다.
            // true 이면 추가된 행은 바로 삭제, 기존에 존재하던 행은 - 표시
            deleteCreated: true
          }
        },
        gridFields: [
          { fieldName: 'Date', dataType: 'string' },
          { fieldName: 'Time', dataType: 'string' },
          { fieldName: 'Inverter_No', dataType: 'string' },
          { fieldName: 'Run_Status', dataType: 'string' }
        ],
        gridColumns: [
          {
            name: 'Date',
            fieldName: 'Date',
            header: {
              text: '일자'
            },
            styles: {
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            },
            // editable 옵션이 false 일 경우, 수정할 수 없다.
            editable: false
          },
          {
            name: 'Time',
            fieldName: 'Time',
            header: {
              text: '시간'
            },
            styles: {
              textAlignment: 'center'
            }
          },
          {
            name: 'Inverter_No',
            fieldName: 'Inverter_No',
            header: {
              text: '인버터 번호'
            },
            styles: {
              textAlignment: 'center',
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            }
          },
          {
            name: 'Run_Status',
            fieldName: 'Run_Status',
            header: {
              text: '고장 이력'
            },
            renderer: {
              type: 'icon',
              iconCallback: function(grid, cell) {
                let image =
                  cell.value === '운전' || cell.value === '대기'
                    ? 'green'
                    : 'red'
                return `/external/runImage/running_${image}.png`
              },
              iconHeight: 15,
              iconWidth: 15
            },
            styles: {
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            }
          }
        ]
      }
    }
  },
  mounted() {},
  computed: {
    gridRetrieveApi() {
      return this.retrieveApi
    }
  },
  watch: {
    tabIndex() {
      this.clearGrid()
    }
  },
  methods: {
    clearGrid() {
      this.$refs.dataGrid.getDataProvider().clearRows()
    },
    retrieveGrid() {
      this.$refs.dataGrid.retrieve()
    },
    retrieveApi() {
      if (this.SITE_ID == '' || this.SITE_ID == null) {
        alert('사이트를 먼저 검색해주세요.')
        return
      }

      let diffDay = day(this.endDate).diff(this.startDate, 'day')
      if (diffDay < 0 || diffDay > 31) {
        Message.err('조회 불가능 날짜입니다.')
        return
      }

      return new Promise((resolve, reject) => {
        let params = {}
        if (this.INVERTER_ID == null || this.INVERTER_ID === '') {
          params =
            '/' +
            this.SITE_ID +
            '/' +
            this.startDate +
            '/' +
            this.endDate +
            '/' +
            0 +
            '/' +
            0
        } else {
          params =
            '/' +
            this.SITE_ID +
            '/' +
            this.startDate +
            '/' +
            this.endDate +
            '/' +
            this.INVERTER_ID +
            '/' +
            this.STATION_ID
        }
        getBrokenRecord(params).then(res => {
          // 21.9.1 AHJ 고장정보 10분마다 수집, 중복정보 삭제
          // let temp = []
          // // console.log(res.brokenRecord.length)
          // for (let i = 1; i < res.brokenRecord.length; i++) {
          //   if (
          //     res.brokenRecord[i - 1].Run_Status !==
          //     res.brokenRecord[i].Run_Status
          //   ) {
          //     temp.push(res.brokenRecord[i - 1])
          //   }
          // }
          // if (res.brokenRecord.length > 0) {
          //   temp.push(res.brokenRecord[res.brokenRecord.length - 1])
          // }
          // // console.log(temp)
          // resolve(temp)
          resolve(res.brokenRecord)
        })
      })
    },
    prevMonth() {
      // 날짜선택
      if (this.endDate === '' || this.endDate == null) {
        this.startDate = day(this.endDate)
          .add(-31, 'day')
          .format('YYYY-MM-DD')
        this.endDate = day().format('YYYY-MM-DD')
      } else {
        this.startDate = day(this.endDate)
          .add(-31, 'day')
          .format('YYYY-MM-DD')
      }
    },

    excelDown() {
      let gridView = this.$refs.dataGrid.getGridView()
      // 엑셀다운로드
      gridView.exportGrid({
        type: 'excel',
        target: 'local',
        fileName: '운전/정지이력_' + day().format('YYYY-MM-DD') + '.xlsx',
        indicator: 'visible',
        footer: 'hidden',
        header: 'visible',
        allColumns: true,
        done: function() {
          Message.success('출력이 완료되었습니다.')
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
#realgrid {
  height: 442.5px;
}

.boxSize {
  width: 150px;
  height: 30px;
}

.dateRange {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  vertical-align: middle;
  padding-right: 10px;
}

.timeSelect {
  width: 130px;
  height: 30px;
  border: 1px solid #666;
  font-size: 12px;
  margin-right: 10px;
  padding-left: 30px;
}
</style>
